import { render, staticRenderFns } from "./input-textarea.component.vue?vue&type=template&id=1361c7f9&"
import script from "./input-textarea.component.ts?vue&type=script&lang=ts&"
export * from "./input-textarea.component.ts?vue&type=script&lang=ts&"
import style0 from "./input-textarea.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports